import Main from '@/views/main/main.vue';
import article from './article';
import pic from './pic';
import tag from './tag';
import exchange from './exchange';
//import announce from './announce';
import ad from './ad';
import journal from './journal';

export default {
    path: '/content',
    name: 'content',
    meta: { icon: 'ios-paper' },
    component: Main,
    children: [...article, ...pic, ...tag, ...ad, ...journal, ...exchange],
};
